export default {
  custom: () => import("/builds/sites/wnhub-general-client/layouts/custom.vue").then(m => m.default || m),
  default: () => import("/builds/sites/wnhub-general-client/layouts/default.vue").then(m => m.default || m),
  fullscreen: () => import("/builds/sites/wnhub-general-client/layouts/fullscreen.vue").then(m => m.default || m)
}